export default "__VITE_ASSET__DrbF6iRN__"